import { formatSecondsDuration } from '../../../../helpers/date/date-helper';

export const ValueDurationChart = ({ value }) => {
  return <div className='text-2xl p-4 h-36 flex items-center justify-center'>{formatSecondsDuration(value || 0)}</div>;
};
